import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as contentful from 'contentful';

import Loader from './components/Loader';
// import About from './components/About';
import Header from './components/Header';
import Splash from './components/Splash';
import Quiz from './components/Quiz';
import Results from './components/Results';

import { updateView, updateLayout, dataLoaded } from './actions';
import getQueryParameterByName from './utils/getQueryParameterByName';
import { shuffle, chunkArray } from './utils/array';

import style from './App.module.scss';

// overrides for dev
const viewOverride = getQueryParameterByName('view');
const viewId = viewOverride ? viewOverride : 'splash';

class App extends Component {
  constructor(props) {
    super(props);

    this.handleResize = this.handleResize.bind(this);
  }

  handleResize() {
    const { dispatch, layout } = this.props;
    const mobile = window.innerWidth < 728 && window.innerWidth < window.innerHeight;

    // only update if there is a change
    if (layout.mobile !== mobile) dispatch(updateLayout(mobile));
  }

  getOverrideQuestions(indexes, questions) {
    const a = indexes.split(',');
    return a.map(index => questions[+index]);
  }

  handleQuizStart() {
    const { dispatch } = this.props;
    dispatch(updateView('quiz'));
  }

  loadAssets(items) {
    // preload the assets
    const preloadItems = [];
    const addToQueue = ({ src }) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = e => resolve(img);
        img.onerror = err => {
          console.log('error loading', src);
          return reject(err);
        }
        img.src = src;
      });
    }

    if (items) {
      items.forEach(item => {
        preloadItems.push(addToQueue(item));
      });
    }
    
    return new Promise((resolve, reject) => {
      Promise.all([...preloadItems])
        .then(() => resolve(items))
        .catch(err => reject(err));
    });
  }

  componentDidMount() {
    const { dispatch, quiz: { questionsToComplete } } = this.props;
    let app = {}, questions = [], archetypes = [], products = [], themes = [];

    const client = contentful.createClient({
      space: process.env.REACT_APP_SPACE,
      environment: 'master',
      accessToken: process.env.REACT_APP_ACCESS_TOKEN
    });

    client.getEntries()
      .then(({ items }) => items.forEach(({ fields }) => {
        if (fields.introSiteTitle) app = fields;
        else if (fields.question) questions.push(fields);
        else if (fields.archetype) products.push(fields);
        else if (fields.personaNumber) archetypes.push(fields);
        else if (fields.name) themes.push(fields);
      }))
      .then(() => {
        const standard = [], beauty = [];
        // shuffle and assign id so we can track order
        questions.forEach((item, idx) => {
          const { answer1, answer2, answer3, answer4 } = item;
          const answers = shuffle([answer1, answer2, answer3, answer4].map((answer, index) => Object.assign({}, { text: answer, index })));
          Object.assign(item, { answers });
        });
        questions.forEach((question, index) => {
          const ordered = Object.assign(question, { index });
          if (question.questionType === 'beauty') beauty.push(ordered);
          else standard.push(ordered);
        }); // order matters, capture initial index
        const pool = chunkArray(shuffle(standard), questionsToComplete)[0]; // -1 so we are able to insert a beauty question

        // TODO: move this to the intitial sort
        archetypes.sort((a, b) => a.personaNumber - b.personaNumber);
        products.forEach(product => {
          const index = product.archetype - 1;
          if (archetypes[index].products) archetypes[index].products.push(product);
          else archetypes[index].products = [product];
        });

        archetypes.forEach(archetype => {
          if (!archetype.products) return archetype.products = [];
          archetype.products.sort((a, b) => {
            if (a.index === undefined) a.index = -1;
            if (b.index === undefined) b.index = -1;
            return a.index - b.index;
          });
        });

        // console.log('loaded...', '\nprops:', this.props, '\nquestions:', questions, '\npool:', pool, '\nbeauty:', beauty, '\napp:', app, '\narchetypes:', archetypes, '\nthemes:', themes);

        // combined dispatchers
        dispatch(dataLoaded({
          questions, pool, beauty,
          app, archetypes, themes,
          loading: false, viewId }));
      });

    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  render() {
    const { base: { app: { loading } }, view: { id } } = this.props;

    return (
      <div className={style.App}>
        <Header />
        {!loading ? <div className={style.views}>
        {id === 'loading' || id === 'splash' ? <Splash /> : null}
          <Quiz />
          <Results />
          {/* <About /> */}
        </div> : <Loader />}
      </div>
    );
  }
} 

const mapStateToProps = state => ({
  view: state.view,
  quiz: state.quiz,
  base: state.base,
  themes: state.themes,
  layout: state.layout
})

export default connect(mapStateToProps)(App);